<template>
  <el-main
    v-loading="!chartData"
    element-loading-background="rgba(122, 122, 122, 0.05)"
    style="height:250px;"
  >
    <Doughnut
      v-if="chartData"
      class="loading"
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </el-main>
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, ArcElement, CategoryScale)

export default {
  name: 'DoughnutChart',
  components: {
    Doughnut
  },
  props: {
    chartId: {
      type: String,
      default: 'doughnut-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 250
    },
    height: {
      type: Number,
      default: 250
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    chartData: {
      type: Object
    }
  },
  data () {
    return {
      chartOptions: {
        borderWidth: 0, // 兩資料間移除白色分隔線
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            yAlign: 'bottom',
            callbacks: {
              // hover的tooltip整理顯示為：

              // [顏色] 閒置中
              // 2支 (67%)
              afterBody: (context) => {
                const index = context[0].dataIndex
                const num = context[0].dataset.data[index]

                let sum = 0
                const dataArr = context[0].dataset.data
                dataArr.map(data => sum += data)
                const percentage = Math.round(num * 100 / sum) + '%'

                return `${num}支 (${percentage})`
              },
              label: (context) => {
                return ` ${context.label}`
              }
            }
          },
          legend: {
            display: false
          }
        },
        cutout: '75%', // doughnut是從pie分割中間來的，移除中間75%的圓
        rotation: 90 // 資料起始位置，在3點鐘方向
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  padding: 0;
}
</style>
